export default (theme) => {
  return [
    {
      featureType: 'all',
      elementType: 'geometry.fill',
      stylers: [
        {
          color: theme === 'light' ? '#f5f7f6' : '#444546',
          visibility: 'on',
        },
      ],
    },
    {
      featureType: 'all',
      elementType: 'geometry.stroke',
      stylers: [
        {
          visibility: theme === 'light' ? 'inherit' : 'on',
          color: theme === 'light' ? 'unset' : '#61666b',
          weight: theme === 'light' ? 'unset' : 1,
        },
      ],
    },
    {
      featureType: 'all',
      elementType: 'labels.text.fill',
      stylers: [
        {
          color: theme === 'light' ? '#a4a3a3' : '#b9c1c8',
        },
      ],
    },
    {
      featureType: 'all',
      elementType: 'labels.text.stroke',
      stylers: [
        {
          color: theme === 'light' ? 'unset' : '#333333',
        },
      ],
    },
    {
      featureType: 'administrative.locality',
      elementType: 'geometry.fill',
      stylers: [
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'administrative.province',
      elementType: 'geometry.fill',
      stylers: [
        {
          visibility: 'on',
        },
      ],
    },
    {
      featureType: 'administrative.neighborhood',
      elementType: 'geometry.fill',
      stylers: [
        {
          visibility: 'on',
        },
      ],
    },

    {
      featureType: 'water',
      elementType: 'geometry.fill',
      stylers: [
        {
          color: theme === 'light' ? '#d1e7f6' : '#181726',
        },
      ],
    },
    {
      featureType: 'water',
      elementType: 'labels.text',
      stylers: [
        {
          color: theme === 'light' ? '#a4a3a3' : '#246f8f',
        },
      ],
    },
    {
      featureType: 'road',
      elementType: 'all',
      stylers: [
        {
          color: theme === 'light' ? '#ffffff' : '#3c3c3c',
          visibility: 'on',
        },
      ],
    },
    {
      featureType: 'road',
      elementType: 'labels.text.fill',
      stylers: [
        {
          color: '#a4a3a3',
        },
      ],
    },
    {
      featureType: 'road.highway',
      elementType: 'all',
      stylers: [
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'poi',
      elementType: 'all',
      stylers: [
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'transit',
      elementType: 'all',
      stylers: [
        {
          visibility: 'off',
        },
      ],
    },
  ]
}


